{
  "title": "Vue d’ensemble",
  "greeting": "Bonjour, {{name}}",
  "description": "Vos téléphones et vos messages en un coup d’œil.",
  "actions": {
    "label": "À traiter",
    "offlineDevices": "Téléphones hors ligne",
    "offlineDevicesHint": "Activés mais silencieux",
    "failed24h": "Échecs sur 24 h",
    "failed24hHint": "Messages qui ne sont pas partis",
    "pendingTopups": "Recharges en attente",
    "pendingTopupsHint": "En attente du paiement",
    "wallet": "Solde du portefeuille",
    "walletExpiry": "Prochaine expiration le {{date}}",
    "walletNoExpiry": "Rien n’expire bientôt",
    "walletLow": "Sous votre seuil d’alerte"
  },
  "usage": {
    "title": "Consommation du forfait",
    "plan": "Forfait {{name}}",
    "today": "Aujourd’hui",
    "month": "Ce mois-ci",
    "used": "{{used}} sur {{limit}}",
    "usedUnlimited": "{{used}} envoyés",
    "unlimited": "Illimité",
    "renews": "Renouvellement le {{date}}",
    "ends": "Fin le {{date}}",
    "buyMore": "Acheter plus",
    "changePlan": "Changer de forfait"
  },
  "figures": {
    "title": "Messages",
    "against": "par rapport à la période précédente",
    "sent": "Envoyés",
    "deliveryRate": "Taux de distribution",
    "failed": "Échecs",
    "received": "Reçus",
    "empty": "Aucun message sur cette période."
  },
  "breakdown": {
    "title": "État de distribution",
    "delivered": "Distribués",
    "failed": "Échecs",
    "notFinal": "Pas encore définitif",
    "notFinalHint": "Envoyés, sans accusé de réception pour l’instant",
    "empty": "Rien d’envoyé sur cette période."
  },
  "devices": {
    "title": "Téléphones les plus actifs",
    "all": "Tous les téléphones",
    "empty": "Ajoutez votre premier téléphone",
    "emptyBody": "Installez l’application sur un téléphone Android : il enverra vos SMS.",
    "add": "Ajouter un téléphone",
    "traffic": "{{sent}} envoyés · {{received}} reçus",
    "lastSeen": "Dernier signal {{when}}",
    "never": "Jamais vu"
  },
  "getStarted": {
    "title": "Pour commencer",
    "body": "Trois étapes jusqu’à votre premier SMS.",
    "device": "Connecter un téléphone",
    "key": "Créer une clé d’API",
    "message": "Envoyer votre premier SMS",
    "done": "Fait",
    "todo": "À faire"
  },
  "traffic": {
    "title": "Trafic",
    "view": "Affichage",
    "chart": "Graphique",
    "table": "Tableau",
    "sent": "Envoyés",
    "received": "Reçus",
    "previous": "Période précédente",
    "previousDay": "Période précédente : {{sent}} envoyés · {{received}} reçus",
    "previousSent": "Envoyés avant",
    "previousReceived": "Reçus avant",
    "day": "Jour",
    "label": "{{sent}} envoyés et {{received}} reçus entre le {{from}} et le {{to}}.",
    "empty": "Aucun message sur cette période."
  }
}
